// Home.jsx
import React, { useState } from 'react';
import './Pages/PagesCss/Home.css';
import { useNavigate } from 'react-router-dom';
import logo from './assets/logo.png';

// SVG Icon Components
const Icons = {
  Merge: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 6H20M4 12H20M4 18H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M17 15L20 18L17 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Split: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 4H4V8M16 4H20V8M8 20H4V16M16 20H20V16M12 4V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Extract: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M8 8H16M8 12H16M8 16H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Organize: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 4H18M6 8H14M6 12H18M6 16H14M6 20H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="20" cy="8" r="2" fill="currentColor"/>
    </svg>
  ),
  Compress: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 8L12 3L20 8V16L12 21L4 16V8Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M12 12L12 21M12 12L16 9M12 12L8 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Repair: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2"/>
      <path d="M12 8V12L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  OCR: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M8 8H16M8 12H16M8 16H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="19" cy="19" r="3" stroke="currentColor" strokeWidth="2"/>
    </svg>
  ),
  Word: (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2" y="3" width="14" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M6 7H12M6 11H12M6 15H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14 7H22V21H8" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeDasharray="2 2"/>
    <path d="M17 11L19 17L21 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
),

PowerPoint: (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2" y="4" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M9 20H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 18V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <rect x="5" y="7" width="8" height="5" rx="1" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M16 8H19M16 11H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
),

Excel: (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M2 9H22" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M2 15H22" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M8 9V21M15 9V21" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
),
  JPG: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
      <circle cx="9" cy="9" r="2" fill="currentColor"/>
      <path d="M20 15L16 11L8 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  HTML: (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 3L5.5 19L12 21L18.5 19L20 3H4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M8 8H16M8.5 12L7 13.5L8.5 15M15.5 12L17 13.5L15.5 15M11 15L13 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
),
JSON: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 4C7 4 6 5 6 7V9C6 10 5 11 4 11C5 11 6 12 6 13V15C6 17 7 18 9 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 4C17 4 18 5 18 7V9C18 10 19 11 20 11C19 11 18 12 18 13V15C18 17 17 18 15 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  ),
  Edit: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M17 3L21 7L7 21H3V17L17 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  ),
  Watermark: (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M5 7H14M5 11H19M5 15H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".5"/>
    <text x="7" y="17" fontSize="7" fontWeight="700" fill="currentColor" opacity=".4"
      transform="rotate(-25 12 12)" fontFamily="serif">DRAFT</text>
  </svg>
),

Rotate: (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="5" y="5" width="12" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M17 3C19.2091 3 21 4.79086 21 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="3 2"/>
    <path d="M19 15L21 17L23 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
),
  Crop: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 4V18H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Sign: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 20H20M6 16L14 8L16 10L8 18H6V16Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    </svg>
  ),
  Unlock: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M8 11V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="12" cy="16" r="1.5" fill="currentColor"/>
    </svg>
  ),
  Protect: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M8 11V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="12" cy="16" r="1.5" fill="currentColor"/>
      <path d="M12 16V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Compare: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="2" y="4" width="8" height="16" rx="1" stroke="currentColor" strokeWidth="2"/>
      <rect x="14" y="4" width="8" height="16" rx="1" stroke="currentColor" strokeWidth="2"/>
      <path d="M6 8H10M6 12H10M6 16H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Redact: (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M5 8H14M5 12H19M5 16H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".4"/>
    <rect x="5" y="10.5" width="9" height="3" rx="0.5" fill="currentColor"/>
    <rect x="11" y="14.5" width="8" height="3" rx="0.5" fill="currentColor"/>
  </svg>
),
  AllTools: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="4" y="4" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="10" y="4" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="16" y="4" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="4" y="10" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="10" y="10" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="16" y="10" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="4" y="16" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="10" y="16" width="4" height="4" rx="1" fill="currentColor"/>
      <rect x="16" y="16" width="4" height="4" rx="1" fill="currentColor"/>
    </svg>
  ),
  Fast: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2"/>
      <path d="M12 8V12L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Secure: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 3L3 7V12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12V7L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Free: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2"/>
      <path d="M12 8V16M8 12H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Accessible: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2"/>
      <circle cx="12" cy="8" r="1.5" fill="currentColor"/>
      <path d="M12 12L12 16M8 14L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  PDF: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 4H20V20H4V4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M8 8H16M8 12H16M8 16H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  OrganizeTab: (props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3 4H17M3 8H13M3 12H17M3 16H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  OptimizeTab: (props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 10L8 6L12 10L16 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  ConvertTab: (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 7H13M13 7L10 4M13 7L10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 13H7M7 13L10 10M7 13L10 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
),
  EditTab: (props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14 3L17 6L6 17H3V14L14 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  ),
  SecurityTab: (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 2L3 5.5V10C3 13.87 6.13 17.5 10 18C13.87 17.5 17 13.87 17 10V5.5L10 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M7 10L9 12L13 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
),
IntelligenceTab: (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 1 L11.8 8.2 L19 10 L11.8 11.8 L10 19 L8.2 11.8 L1 10 L8.2 8.2 Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 3 L17.5 4.5 L19 5 L17.5 5.5 L17 7 L16.5 5.5 L15 5 L16.5 4.5 Z" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 15 L3.4 16.2 L4.6 16.6 L3.4 17 L3 18.2 L2.6 17 L1.4 16.6 L2.6 16.2 Z" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
),
Delete: (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
),
Flatten: (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 6H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M6 9H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M8 12H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 15V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
),
Summarizer: (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 6H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4 10H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4 14H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="16" cy="16" r="3" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M16 14V17l1.5 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
),
Translate: (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 2C7 5 6 8 6 10s1 5 4 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 2C13 5 14 8 14 10s-1 5-4 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M2 10H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M3 7H17M3 13H17" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
  </svg>
),
};

const Home = () => {
  const [activeTab, setActiveTab] = useState('all');
  const navigate = useNavigate();

  const tools = {
    organize: [
      { icon: Icons.Merge, name: 'Merge PDF', path: '/PDFMerger', description: 'Combine PDFs in the order you want' },
      { icon: Icons.Split, name: 'Split PDF', path: '/PDFSplit', description: 'Separate PDF pages into multiple files' },
      { icon: Icons.Extract, name: 'Extract Pages', path: '/PDFExtractPages', description: 'Extract specific pages from your PDF' },
      { icon: Icons.Organize, name: 'Organize PDF', path: '/PDFOrganizer', description: 'Reorder, delete, or insert pages' },
      { icon: Icons.Delete, name: 'Delete Pages', path: '/PDFDeletePages', description: 'Delete unwanted pages from your PDF' },
    ],
    optimize: [
      { icon: Icons.Compress, name: 'Compress PDF', path: '/PDFCompress', description: 'Reduce file size for easier sharing' },
      { icon: Icons.Repair, name: 'Repair PDF', path: '/PDFRepair', description: 'Fix corrupted or damaged PDF files' },
      { icon: Icons.OCR, name: 'OCR PDF', path: '/PDFOCR', description: 'Make scanned PDFs searchable and editable' },
      { icon: Icons.Flatten, name: 'Flatten PDF', path: '/PDFFlatten', description: 'Make PDF content non-editable by merging layers' },
    ],
    convert: [
      { icon: Icons.Word, name: 'PDF to Word', path: '/PDFToWord', description: 'Easily convert PDF to editable Word' },
      { icon: Icons.PowerPoint, name: 'PDF to PowerPoint', path: '/PDFToPowerPoint', description: 'Convert PDF to PowerPoint' },
      { icon: Icons.Excel, name: 'PDF to Excel', path: '/PDFToExcel', description: 'Extract tables from PDF to Excel' },
      { icon: Icons.Word, name: 'Word to PDF', path: '/WordToPDF', description: 'Convert Word documents to PDF' },
      { icon: Icons.PowerPoint, name: 'PowerPoint to PDF', path: '/PowerPointToPDF', description: 'Convert PowerPoint to PDF' },
      { icon: Icons.Excel, name: 'Excel to PDF', path: '/ExcelToPDF', description: 'Convert Excel spreadsheets to PDF' },
      { icon: Icons.JPG, name: 'PDF to JPG', path: '/PDFToJPG', description: 'Convert PDF pages to JPG images' },
      { icon: Icons.JPG, name: 'JPG to PDF', path: '/JPGToPDF', description: 'Convert JPG images to PDF' },
      { icon: Icons.HTML, name: 'HTML to PDF', path: '/HTMLToPDF', description: 'Convert web pages to PDF' },
      { icon: Icons.PDF, name: 'PDF to PDF/A', path: '/PDFToPDFA', description: 'Convert to archival PDF format' },
      { icon: Icons.JSON, name: 'JSON to PDF', path: '/JSONToPDF', description: 'Convert JSON data into a PDF document' },
    ],
    edit: [
      { icon: Icons.Edit, name: 'Edit PDF', path: '/PDFEdit', description: 'Add text, images, or annotations' },
      { icon: Icons.Watermark, name: 'Add Watermark', path: '/PDFAddWatermark', description: 'Add text or image watermarks' },
      { icon: Icons.Watermark, name: 'Remove Watermark', path: '/PDFRemoveWatermark', description: 'Remove watermarks from PDF' },
      { icon: Icons.Rotate, name: 'Rotate PDF', path: '/PDFRotate', description: 'Rotate pages in your PDF' },
      { icon: Icons.Edit, name: 'Add Page Numbers', path: '/AddPDFPageNumber', description: 'Insert page numbers' },
      { icon: Icons.Crop, name: 'Crop PDF', path: '/PDFCrop', description: 'Crop pages to custom size' },
    ],
    security: [
      { icon: Icons.Sign, name: 'Sign PDF', path: '/PDFSign', description: 'Add signatures and initials' },
      { icon: Icons.Unlock, name: 'Unlock PDF', path: '/PDFUnlock', description: 'Remove password protection' },
      { icon: Icons.Protect, name: 'Protect PDF', path: '/PDFProtect', description: 'Add password to your PDF' },
      { icon: Icons.Compare, name: 'Compare PDF', path: '/PDFCompare', description: 'Compare two PDF files' },
      { icon: Icons.Redact, name: 'Redact PDF', path: '/PDFRedact', description: 'Permanently remove sensitive info' },
    ],
    intelligence: [
      { icon: Icons.Summarizer, name: 'PDF Summarizer', path: '/PDFSummary', description: 'Generate a quick summary of your PDF' },
      { icon: Icons.Translate, name: 'Translate PDF', path: '/PDFTranslate', description: 'Translate PDF content into different languages' },
    ],
  };

  // Calculate total number of tools
  const totalTools = Object.values(tools).flat().length;

  const filterTools = () =>
    activeTab === 'all' ? Object.values(tools).flat() : (tools[activeTab] || []);

  const tabs = [
    { id: 'all', label: 'All Tools', icon: Icons.AllTools },
    { id: 'organize', label: 'Organize', icon: Icons.OrganizeTab },
    { id: 'optimize', label: 'Optimize', icon: Icons.OptimizeTab },
    { id: 'convert', label: 'Convert', icon: Icons.ConvertTab },
    { id: 'edit', label: 'Edit', icon: Icons.EditTab },
    { id: 'security', label: 'Security', icon: Icons.SecurityTab },
    { id: 'intelligence', label: 'Intelligence', icon: Icons.IntelligenceTab },
  ];

  const features = [
    { icon: Icons.Fast, title: 'Fast Processing', desc: 'Process PDFs in seconds with our optimized engine' },
    { icon: Icons.Secure, title: 'Secure & Private', desc: 'Files are automatically deleted after processing' },
    { icon: Icons.Free, title: 'All-in-One PDF Tools', desc: 'Merge, split, convert, compress and edit PDFs in one place' },
    { icon: Icons.Accessible, title: 'Accessible Anywhere', desc: 'Works on all devices' },
  ];

  return (
    <div className="home">

      {/* Hero Section - Updated with left content and right logo */}
      <section className="hero-section">
        <div className="container hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="hero-badge-dot" />
              100% Free · Trusted by millions
            </div>
            <h1 className="hero-title">
              <span className="highlight">Quick</span>PDFs.net
            </h1>
            <p className="hero-subtitle">
              Every tool you need to work with PDFs in one place
            </p>
            <div className="hero-description">
              <p className="hero-description-text">
                All the PDF tools you'll ever need, right at your fingertips
                completely <strong>100% FREE</strong> and easy to use.
                Merge, split, compress, convert, rotate, unlock and watermark with just a few clicks.
              </p>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-number">{totalTools}+</span>
                <span className="hero-stat-label">PDF Tools</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">5M+</span>
  <span className="hero-stat-label">PDFs Processed</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">99%</span>
  <span className="hero-stat-label">Uptime Reliability</span>
              </div>
            </div>
            <div className="hero-buttons">
    <button className="btn btn-primary" onClick={() => navigate('/PDFTools')}>
      Explore All Tools
    </button>
    <button className="btn btn-secondary" onClick={() => navigate('/PDFToWord')}>
      Get Started
    </button>
  </div>
          </div>
          <div className="hero-logo">
            <div className="logo-animation">
             <img src={logo} alt="logo" className="hero-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Tools Section */}
      <section className="tools-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">PDF Toolkit</span>
            <h2 className="section-title">Powerful PDF tools</h2>
            <p className="section-subtitle">Everything you need to work with PDFs, completely free</p>
          </div>

          {/* Tab Navigation */}
          <div className="tabs-container">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="tab-icon">
                  <tab.icon />
                </span>
                <span className="tab-label">{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Tools Grid */}
          <div className="tools-grid">
            {filterTools().map((tool, index) => (
              <div key={index} className="tool-card" onClick={() => navigate(tool.path)}>
                <div className="tool-icon">
                  <tool.icon />
                </div>
                <h3 className="tool-name">{tool.name}</h3>
                <p className="tool-description">{tool.description}</p>
                <button className="tool-btn" type="button">
                  Select PDF →
                </button>
              </div>
            ))}
          </div>

          <div className="view-all">
            <a href="/PDFTools" className="view-all-link">
              View all tools <span className="arrow">→</span>
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="features-content">
            <div className="section-header">
              <span className="section-label">Why QuickPDFs</span>
              <h2 className="section-title">Trusted by millions of users</h2>
            </div>
            <p className="features-description">
              QuickPDFs.net is your number one web app for working with PDFs.
              Enjoy all the tools you need to work efficiently with your digital
              documents while keeping your data safe and secure.
            </p>
            <div className="features-grid">
              {features.map((f, i) => (
                <div className="feature-item" key={i}>
                  <div className="feature-icon-wrap">
                    <f.icon />
                  </div>
                  <h4>{f.title}</h4>
                  <p>{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">Ready to start?</h2>
          <p className="cta-subtitle">
            Join millions of users who trust QuickPDFs.net for their PDF needs
          </p>
          <div className="cta-buttons">
            <button className="btn btn-primary btn-large" onClick={() => navigate('/PDFMerger')}>
              Get Started It's Free
            </button>
            <button className="btn btn-secondary btn-large" onClick={() => navigate('/PDFTools')}>
              View All Tools
            </button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;